// Internet Explorer が Promise 非対応のため、代替コンポーネントを使用
//   https://github.com/getify/native-promise-only
//   npm install --save native-promise-only
import Promise from 'native-promise-only'

// Ajax
//   https://github.com/visionmedia/superagent
//   npm install --save superagent
import request from 'superagent'

import * as Defs from './define'
import { showMaintenanceDlg } from './utils'

// API接続先
import { PATH } from './webapiPath'

import { IS_DEBUG } from './is_debug'

// superagent-no-cache
//   Plugin for visionmedia/superagent that adds headers to all requests that prevents caching
//   npm install --save superagent-no-cache
var noCache = require('superagent-no-cache')

/**
 * 最新バージョン情報取得
 * @returns {Promise} - バージョン情報
 */
export function getUIVersion() {
  if (!IS_DEBUG) {
    // Revisonチェック開始（キャッシュ無効にするためハッシュを付けて確認する）
    const hash = new Date().getTime()
    return new Promise(function (resolve, reject) {
      request
        .get('/init/version.json?' + hash)
        .use(noCache)
        .set('Accept', 'application/json')
        .end(function (err, res) {
          if (err) {
            reject(err)
          } else {
            resolve(res.body)
          }
        })
    })
  } else {
    return new Promise(function (resolve, reject) {
      //resolve(require('../package.json'))
      resolve({ version: '9,9,9' })
    })
  }
}

/**
 * 初回登録用ログイン
 * @param {string} serial - シリアル番号
 * @param {string} phone - 電場番号
 */
export function loginInitialRegistration(serial, phone) {
  // 電話番号から数字以外を除去する
  let pn = phone.replace(/[^0-9]/g, '')
  return new Promise(function (resolve, reject) {
    request.post(PATH + 'contracts/token')
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send({ serialNumber: serial, phoneNumber: pn })
      .end(function (err, res) {
        if (err) {
          reject(err)
        } else {
          resolve(JSON.parse(res.text))
        }
      })
  })
}

/**
 * 契約IDが既に使用済みかどうかの確認
 * @param {string} token - 認証トークン
 * @param {string} id - 確認する契約ID
 */
export function checkContractId(token, id) {
  return new Promise(function (resolve, reject) {
    request.get(PATH + 'tenants/@' + id)
      .use(noCache)
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer ' + token)
      //.query({})
      .end(function (err, res) {
        if (err) {
          reject(err)
        } else {
          // resolve(JSON.parse(res.text))
          resolve({})
        }
      })
  })
}

/**
 * メールアドレスの検証 - 検証メールの送信
 * @param {string} token 
 * @param {string} mailAddress 
 */
export function sendConfirmationMail(token, mailAddress) {
  return new Promise(function (resolve, reject) {
    request.post(PATH + 'contracts/email/confirm')
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer ' + token)
      .send({ email: mailAddress })
      .end(function (err, res) {
        if (err) {
          reject(err)
        } else {
          //resolve(JSON.parse(res.text))
          resolve({})
        }
      })
  })
}

/**
 * メールアドレスの検証 - 認証コードの確認
 * @param {string} token - トークン
 * @param {string} mailAddress - メールアドレス
 * @param {string} confirmationCode - 認証コード
 */
export function confirmMailAddress(token, mailAddress, confirmationCode) {
  return new Promise(function (resolve, reject) {
    request.post(PATH + 'contracts/email/verify')
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer ' + token)
      .send({ email: mailAddress, code: confirmationCode })
      .end(function (err, res) {
        if (err) {
          reject(err)
        } else {
          // resolve(JSON.parse(res.text))
          resolve({})
        }
      })
  })
}

/**
 * 初回登録
 * @param {string} token - 認証トークン
 * @param {Object} param - 登録する情報
 */
export function registerInitialData(token, param) {
  return new Promise(function (resolve, reject) {
    request.post(PATH + 'tenants')
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer ' + token)
      .send({
        tenantName: param.contractId,
        tenantDisplayName: param.contractId,
        email: param.adminMailAddress,
        adminUserName: param.adminId,
        adminUserDisplayName: param.adminName,
        adminUserPassword: param.adminPW1,
        adminUserPasswordConfirmation: param.adminPW2,
        companyName: param.companyId,
        companyDisplayName: param.companyName,
        companyPassword: param.companyPW1,
        companyPasswordConfirmation: param.companyPW2,
        passwordValidDays: param.pwEffectiveDays,
        useImage: param.needPicture,
        useLocation: param.needLocation
      })
      .end(function (err, res) {
        if (err) {
          reject(err)
        } else {
          // resolve(JSON.parse(res.text))
          resolve({})
        }
      })
  })
}

/**
 * 契約の結び付けの確認
 * @param {string} token - トークン
 * @param {string} tenantId - 契約ID
 * @param {string} adminUserId - 管理者ID
 * @param {string} password - パスワード
 * @returns {object} - テナント情報
 */
export function confirmAttachContract(token, tenantId, adminUserId, password) {
  return new Promise(function (resolve, reject) {
    request
      .post(PATH + 'tenants/confirm-attach-contract')
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer ' + token)
      .send({
        tenantName: tenantId,
        adminUserName: adminUserId,
        password: password,
      })
      .end(function (err, res) {
        if (err) {
          reject(err)
        } else {
          resolve(res.body)
        }
      })
  })
}

/**
 * 契約の結び付け
 * @param {string} token - トークン
 * @param {string} tenantId - 契約ID
 * @param {string} adminUserId - 管理者ID
 * @param {string} password - パスワード
 * @returns {object} - テナント情報
 */
export function attachContract(token, tenantId, adminUserId, password) {
  return new Promise(function (resolve, reject) {
    request
      .post(PATH + 'tenants/attach-contract')
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer ' + token)
      .send({
        tenantName: tenantId,
        adminUserName: adminUserId,
        password: password,
      })
      .end(function (err, res) {
        if (err) {
          reject(err)
        } else {
          resolve(res.body)
        }
      })
  })
}

/**
 * API呼び出し エラー処理
 * @param {Object} err - エラーオブジェクト
 * @param {func} [callbackFunc] - 再試行時に呼ぶ関数
 * @param {*} [param] - 再試行時間数に渡す引数
 */
export function handleAPIError(err, callbackFunc, param) {
  if (typeof callbackFunc !== 'function') {
    return
  }
  // console.error(err)
  switch (err.status) {
    case 400: // パラメータ不正
      if (checkErrorCode(err, Defs.API_ERROR_CODE.MAINTENANCE)) {
        // メンテナンス中
        const endTime = err.response.body.maintenanceEndTime
        showMaintenanceDlg(callbackFunc, endTime, true)
        return
      }
      break
    case 401: // token有効期限切れ
      callbackFunc('RELOGIN', { retryFunc: param.retryFunc, retryFuncParam: param.retryFuncParam })
      return
    case 500: // サーバー インターナルエラー
      callbackFunc('MSGBOX', { msgTitle: 'サーバー エラー', msgBody: 'サーバーに接続できません。\n少し時間をおいてから、再度実行してください。', forceLogout: true })
      return
    case 503: // APIサーバー メンテナンス中
      callbackFunc('MSGBOX', { msgTitle: 'サーバーメンテナンス中', msgBody: 'メンテナンス等の理由により、サーバーに接続できません。', forceLogout: true })
      return
    default:
      break
  }
  callbackFunc('APIERR', { forceLogout: true })
}

/**
 * APIエラーにエラーコードが含まれているか判定します。
 * @param {Object} error - エラーデータ
 * @param {Number} errorCode - 判定するエラーコード
 * @returns {Bool} - 指定されたエラーコードが含まれていればTrue
 */
export function checkErrorCode(error, errorCode) {
  return error !== null && 'response' in error
    && error.response !== null && 'body' in error.response
    && error.response.body !== null && 'errorCode' in error.response.body
    && error.response.body.errorCode === errorCode
}



// WEBPACK FOOTER //
// ./src/webapi.js